import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { productionBatchStatistics } from '@reducers/statistics';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { getNCFileById } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getPartByID } from '@reducers/parts';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';

interface BatchDetailsPartTimelineProps {}

const BatchDetailsPartTimelineComponent: FC<BatchDetailsPartTimelineProps> = ({
  clearTools,
  getNCFileById,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
  getPartByID,
}) => {
  const title = useTitle();

  useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
    getPartByID,
  });

  return (
    <DetailsPageWrapper title={title.part}>
      <MultiMachineTimeline />
    </DetailsPageWrapper>
  );
};

const BatchDetailsPartTimeline = connect(null, {
  clearTools,
  getNCFileById,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
  getPartByID,
})(BatchDetailsPartTimelineComponent);

export { BatchDetailsPartTimeline };
